<div class="flex w-full items-center justify-between min-h-14 min-w-0">
  <div class="flex gap-2.5 items-center min-w-0 flex-1">
    <mat-icon
      fontIcon="pin_drop"
      class="hidden md:inline-flex materials-symbols-outlined icon-muted"
    />
    <p class="truncate">
      {{ location().name }}
    </p>

    @if (location().files().length > 0) {
      <div
        (click)="toggleFile($event)"
        [class.border-proffeo-surface-off]="filesVisible()"
        [class.border-opacity-50]="filesVisible()"
        [class.border-proffeo-border]="!filesVisible()"
        class="shrink-0 cursor-pointer flex gap-1 items-center px-1.5 py-0.5 border-2 rounded-md hover:border-proffeo-surface-off"
      >
        <mat-icon
          fontIcon="attach_file"
          class="icon-sm"
        />
        <p class="text-sm">{{ locationFiles().length }}</p>
      </div>
    }
  </div>

  @if (!location().readOnly) {
    <button
      [matMenuTriggerFor]="matUserMenu"
      [attr.aria-label]="'project-locations.actions.more-actions' | translate"
      mat-icon-button
      type="button"
      class="shrink-0"
    >
      <mat-icon
        aria-hidden="true"
        fontIcon="more_vert"
        class="more-actions-icon"
      />
    </button>
    <mat-menu #matUserMenu>
      <button
        (click)="openEditLocationDialog(location())"
        mat-menu-item
        proffeoMenuAction
      >
        <mat-icon fontIcon="edit" />
        <span>{{ 'project-locations.actions.edit' | translate }}</span>
      </button>
      <button
        (click)="openAddLocationDialog(location())"
        mat-menu-item
        proffeoMenuAction
      >
        <mat-icon fontIcon="add" />
        <span>{{ 'project-locations.actions.add-sublocation' | translate }}</span>
      </button>
      <button
        (click)="openProjectLocationDeleteConfirmationDialog(location())"
        mat-menu-item
        proffeoMenuAction
      >
        <mat-icon fontIcon="delete" />
        <span>{{ 'project-locations.actions.delete' | translate }}</span>
      </button>
      <button
        (click)="openAddMultipleLocationDialog(location())"
        mat-menu-item
        proffeoMenuAction
      >
        <mat-icon fontIcon="add_location" />
        <span>{{ 'project-locations.actions.add-multiple-sublocations' | translate }}</span>
      </button>
      <button
        (click)="openChangeProjectLocationParentDialog()"
        mat-menu-item
        proffeoMenuAction
      >
        <mat-icon fontIcon="find_replace" />
        <span>{{ 'project-locations.actions.change-parent' | translate }}</span>
      </button>
      <button
        (click)="openDuplicateProjectLocationDialog()"
        mat-menu-item
        proffeoMenuAction
      >
        <mat-icon fontIcon="content_copy" />
        <span>{{ 'project-locations.actions.duplicate' | translate }}</span>
      </button>
    </mat-menu>
  }
</div>
@if (filesVisible()) {
  <div class="w-full flex items-center gap-2 px-2 py-2">
    <div class="flex-1 min-w-0">
      <proffeo-thumbnails-carousel
        (fileDelete)="onFileDelete($event)"
        (thumbnailClick)="onThumbnailClick($event)"
        [files]="locationFiles()"
        [allowDelete]="true"
      ></proffeo-thumbnails-carousel>
    </div>

    <proffeo-file-drop
      (filesAdded)="onFilesAdded($event)"
      mode="thumbnail"
      class="shrink-0"
    ></proffeo-file-drop>
  </div>
}
